import { Injectable } from '@angular/core';
import { ScrollableModal } from '@egovsolutions/angular-scrollable-modal';
import { PPTContactBidderComponent } from '@/app/modules/ppt/pages/bill/components/dialogs/contact-bidder/contact-bidder.component';

@Injectable({ providedIn: 'any' })
export class PPTDialogs
{
    constructor
    (
        // Dependencies

        private readonly scrollableModal: ScrollableModal,
    )
    {}


    // Bidder

    public showContactBidderDialog(billId: string)
    {
        this.scrollableModal.open(PPTContactBidderComponent, { data: billId, autoFocus: true });
    }
}
